<template>
  <div>
    <oil-form v-if="loading"
              :title="title"
              :items="waybill"
              :createForm="!waybill.Id"
              :keys="keys"
              :formCallback="formCallback"
              @SupplierId="changeSupplier"
              @EmpowermentId="changeEmpowerment"
              @ProductId="changeProduct"
              @ContractId="changeContract"
              @AppendixId="changeAppendix"
    >
      <template v-slot:File="{input}">
        <v-file-input
            @change="file"
            :disabled="!input.isEdit"
            :label="label"
            dense outlined
        />
      </template>
      <template v-slot:Download='{input}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                   class='my-3'
                   @click='dow(waybill)'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Скачать</span>
        </v-tooltip>
      </template>
    </oil-form>
  </div>
</template>

<script>
import keys from './setting/waybill.json'
import {coreApi} from "~/services/core"
import {productsService} from '@/services/ProductsService'
import {num2str} from "~/utils/functions/MoneyFromString"
import { fileService } from '~/services/FileNextNumberService'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    DatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  props: {
    id: String
  },
  data() {
    return {
      loading: false,
      title: 'Создать ТТН',
      waybill: {
        Supplier: {},
        Attachment: {},
        Product: {},
        Contract: {},
        Appendix: {},
        Empowerment: {},
        File: {},
        Number: '',
        ProductInTons: '',
        StartDate: '',
        TotalSumac: '',
        TotalSumacWords: '',
        Comment: '',
      },
      suppliers: [],
      products: [],
      empowerments: [],
      contracts: [],
      appendixes: [],
      keys: keys,
      label: 'Загрузить файл'
    }
  },
  async created() {
    const suppliers = await coreApi.get('suppler')
    this.suppliers = suppliers.data || []
    const products = await productsService.getAll()
    this.products = products.data || []
    const empowerments = await coreApi.get('coming-empowerment')
    this.empowerments = empowerments.data || []

    if (this.id) {
      this.title = 'Инфо о ТТН'
      const waybill = await coreApi.get(`coming-waybill?id=${this.id}`)
      this.label = waybill.data?.Attachment?.Name || 'загрузить файл'
      this.waybill = waybill.data
      this.contracts = this.waybill.Supplier.Contracts
      this.appendixes = this.waybill.Contract.Appendixes
    }

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message(){
      return this.id ? 'ТТН удачно изменен' : 'ТТН удачно создан'
    }
  },
  methods: {
    async formCallback(data, input,form,func) {

      input.isEdit = false

      const response = await this.storeType('coming-waybill', data)

      if (!response.data) {
        input.isEdit = true
        return;
      }

      this.waybill = response.data

      func(this.message)

      if (!this.id) {
        await this.$router.push({
          name: 'coming-waybill',
          params: {id: this.waybill.Id}
        })
      }

    },
    changeProduct(product) {
      if (!product) return
      this.waybill.Product = {...product}
    },
    changeSupplier(supplier) {
      if (!supplier) return
      this.contracts = supplier.Contracts
      this.waybill.Supplier = {...supplier}

    },
    changeEmpowerment(empowerment) {
      if (!empowerment) return
      this.waybill.Empowerment = {...empowerment}
    },
    changeContract(contract) {
      if (!contract) return
      this.waybill.Contract = {...contract}
      this.appendixes = contract.Appendixes
    },
    changeAppendix(appendix) {
      if (!appendix) return
      this.waybill.Appendix = {...appendix}
    },
    async file(file) {
      const fileId = await fileService.generateId()
      const res = await fileService.upload(fileId.data.Id, file)
      this.waybill.Attachment = res.data
    }
  },
  watch: {
    suppliers(importers) {
      this.keys["Supplier.Id"].attrs.items = importers
    },
    products(products) {
      this.keys["Product.Id"].attrs.items = products
    },
    empowerments(empowerments) {
      this.keys["Empowerment.Id"].attrs.items = empowerments
    },
    appendixes(appendixes) {
      this.keys["Appendix.Id"].attrs.items = appendixes
    },
    contracts(contracts) {
      this.keys["Contract.Id"].attrs.items = contracts
    },
    'waybill.TotalSumac'(total) {
      this.waybill.TotalSumacWords = num2str(total)
    }
  }
}
</script>